import { render, staticRenderFns } from "./ExtraServicesAdminView.vue?vue&type=template&id=112e987e&scoped=true"
import script from "./ExtraServicesAdminView.vue?vue&type=script&lang=js"
export * from "./ExtraServicesAdminView.vue?vue&type=script&lang=js"
import style0 from "./ExtraServicesAdminView.vue?vue&type=style&index=0&id=112e987e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112e987e",
  null
  
)

export default component.exports